(function () {
    "use strict";

    angular.module("virtualFairs")
        .controller("VirtualFairSettingsFormController", VirtualFairSettingsFormController);

    VirtualFairSettingsFormController.$inject = ["VirtualFairService", "InvoicesService", "CountriesNewService", "virtualfair", "toastr", "$state"];

    function VirtualFairSettingsFormController(VirtualFairService, InvoicesService, CountriesNewService, virtualfair, toastr, $state) {

        var vm = this;

        vm.isNovvaEvent = null;

        vm.selectExpoTypes = selectExpoTypes;
        vm.selectServiceRegions = selectServiceRegions;
        vm.selectCostCenter = selectCostCenter;
        vm.getTitle = getTitle;
        vm.selectCurrencies = selectCurrencies;
        vm.addPavilion = addPavilion;
        vm.removePavilion = removePavilion;
        vm.addExpoSession = addExpoSession;
        vm.removeExpoSession = removeExpoSession;
        vm.mountVirtualFair = mountVirtualFair;
        vm.saveVirtualFairSettings = saveVirtualFairSettings;
        vm.goToList = goToList;
        vm.logisticsToPdf = logisticsToPdf;
        vm.changeNetworkingEvent = changeNetworkingEvent;
        vm.selectEventGroups = selectEventGroups;
        vm.selectProfileTypes = selectProfileTypes;
        vm.title = "Create Virtual Event"
        vm.logoPreview = '';
        vm.flag = true;
        vm.changePlatform = changePlatform;
        vm.selectPavilionThumb = selectPavilionThumb;
        vm.setDates = setDates;
        vm.selectAll = selectAll;
        vm.removeAll = removeAll;
        vm.selectTerritories = selectTerritories;
        vm.selectedTerritories = [];
        vm.getCountries = getCountries;
        vm.selectedCountries = [];
        vm.setStudentsAudience = setStudentsAudience;
        vm.selectCountries = selectCountries;
        vm.setExhibitorsCountry = setExhibitorsCountry;

        vm.logicOptions = [
            { id: 0, name: 'No' },
            { id: 1, name: 'Yes' }
        ];

        vm.eventsColors = [
            { colors: '{"background":"#FFD200","text":"#000000"}', name: 'TSW' },
            { colors: '{"background":"#E62431","text":"#FFFFFF"}', name: 'EduCanada / Study in Canada' },            
            { colors: '{"background":"#0A79C5","text":"#FFD200"}', name: 'Study in Sweden' },
            { colors: '{"background":"#c2350e","text":"#f5ce3a"}', name: 'Study in Spain' },
            { colors: '{"background":"#000091","text":"#FFFFFF"}', name: 'Study in France' },
            { colors: '{"background":"#0059b7","text":"#FFFFFF"}', name: 'Study in Europe' },
        ];

        vm.dateOptions = {
            autoUpdateInput: true,
            autoApply: true,
            singleDatePicker: true,
            showTimepicker: false,
            locale: {
                format: "DD/MM/YYYY",
                cancelLabel: "Close"
            },
        };

        vm.dateTimeOptions = {
            autoUpdateInput: true,
            autoApply: true,
            singleDatePicker: true,
            showTimepicker: true,
            locale: {
                format: "DD/MM/YYYY HH:MM",
                cancelLabel: "Close"
            },
        };

        vm.platformOptions = [
            { id: 0, name: '2D' },
            { id: 1, name: '3D' }
        ];

        vm.pavilionThumbs = [
            {
                style: 'b0',
                image: "https://static.edufindme.com/cybersessions/images/b0.png"
            },
            {
                style: 'b1',
                image: "https://static.edufindme.com/cybersessions/images/b1.png"
            },
            {
                style: 'b2',
                image: "https://static.edufindme.com/cybersessions/images/b2.png"
            },
            {
                style: 'b3',
                image: "https://static.edufindme.com/cybersessions/images/b3.png"
            },
            {
                style: 's0',
                image: "https://static.edufindme.com/cybersessions/images/s0.png"
            },
            {
                style: 's1',
                image: "https://static.edufindme.com/cybersessions/images/s1.png"
            },
            {
                style: 's2',
                image: "https://static.edufindme.com/cybersessions/images/s2.png"
            },
            {
                style: 's3',
                image: "https://static.edufindme.com/cybersessions/images/s3.png"
            },
            {
                style: 's4',
                image: "https://static.edufindme.com/cybersessions/images/s4.png"
            }
        ];


        // vm.platformOptions = [
        //     { id: 1, name: 'No' },
        //     { id: 2, name: 'Yes' }
        // ];

        async function selectExpoTypes() {
            await VirtualFairService.getExpoTypes().then(function (response) {
                vm.expotypes = response.data;
            })
        }

        async function selectServiceRegions() {
            await VirtualFairService.getServiceRegions().then(function (response) {
                vm.serviceRegions = response.data;
            });
        }

        async function selectCostCenter() {
            await InvoicesService.getInvoicesCostCenterCategory().then(function (response) {
                vm.costCenters = response.data;
            });

        }

        async function selectCurrencies() {
            await InvoicesService.getCurrencies().then(function (response) {
                vm.currencies = response.data;
            })
        }

        async function getTitle() {
            if (vm.virtualfair) {
                vm.title = "Edit Virtual Event"
            }
            return await vm.title;
        }

        async function addPavilion(pavilion = null) {
            vm.virtualfair.pavilions.push({
                id: pavilion ? pavilion.id : null,
                name: pavilion ? pavilion.name : null,
                sponsor: pavilion ? pavilion.sponsor : false,
                image: pavilion ? pavilion.image : null,
                dome: pavilion ? pavilion.dome : null,
                position: pavilion ? pavilion.position: null,
                style: pavilion ? pavilion.style : null
            })

            return await vm.virtualfair.pavilions
        }

        async function removePavilion(pavilion) {
            if (typeof vm.virtualfair.pavilions === 'object' && vm.virtualfair.pavilions.length > 1) {
                vm.virtualfair.pavilions.splice(vm.virtualfair.pavilions.indexOf(pavilion), 1);
            }
            return await vm.virtualfair.pavilions;
        }

        async function selectPavilionThumb(pavilion, thumb, pavIndex) {
            if (typeof vm.virtualfair.pavilions === 'object' && vm.virtualfair.pavilions.length > 0) {
                vm.virtualfair.pavilions = vm.virtualfair.pavilions.map((pav, idx) => {
                    if(idx === pavIndex){
                        return {
                            ...pav,
                            image: thumb.image,
                            style: thumb.style
                        }
                    }
                    return pav
                });
            }
            console.log(vm.virtualfair.pavilions)
            return await vm.virtualfair.pavilions;
        }

        async function addExpoSession(session = null) {
            vm.virtualfair.sessions.push({
                id: session ? session.id : null,
                expo_date: session ? session.expo_date : null,
                start_datetime_utc: session ? session.start_datetime_utc : null,
                end_datetime_utc: session ? session.end_datetime_utc : null,
                time_your_city: session ? session.time_your_city : null,
                close_platform_datetime_utc: session ? session.close_platform_datetime_utc : null
            });
            return await vm.virtualfair.sessions;
        }

        async function removeExpoSession(session) {
            if (typeof vm.virtualfair.sessions === 'object' && vm.virtualfair.sessions.length > 1) {
                vm.virtualfair.sessions.splice(vm.virtualfair.sessions.indexOf(session), 1);
            }
            return await vm.virtualfair.sessions;
        }

        async function mountVirtualFair() {
            var defaultColor = vm.eventsColors.find(function(item) {
                return item.name === 'TSW';
            });

            var defaultCountry = vm.exhibitorsCountries.find(function(item) {
                return item.name === 'Worldwide';
            });

            let defaultCurrency = vm.currencies.find(function(item) {
                return item.code === 'USD';
            });

            let defaultNo = vm.logicOptions.find(function(item) {
                return item.id === 0;
            });
                        
            vm.virtualfair = {
                id: null,
                name: "",
                title: "",
                expo_type_id: "",
                is_workshop: "",
                // is_high_school: "",
                has_networking_event: "",
                target_region: "",
                target_students: "",
                target_exhibitors: "Wordwide",
                booths_limit: "",
                description: "",
                logistics_url: "",
                school_profile_url: "",
                service_regions: [],
                pavilions: [],
                sessions: [],
                early_bird_datetime_utc: "",
                registration_deadline: "",
                booth_setup_deadline: "",
                student_registration_deadline: "",
                scheduling_deadline: "",
                currency: "",
                cost_center: "",
                early_bird_rate: 0.00,
                rate: 0.00,
                logistics_pdf: "",
                image: "",
                description_event_ics: "",
                description_booth_setup_ics: "",
                max_representatives: "",
                event_group_id: "",
                profile_types: [],
                platform_system: 2,
                calendar_id: "",
                room_free_limit: 2,
                room_rate: 500,
                room_max_visitors: 20,
                ai_agent_rate: 0.00,
                event_colors: defaultColor,
                exhibitors_country: defaultCountry,
                students_countries: [],
                currency: defaultCurrency.code,
                canceled: defaultNo.id,
                has_matching: defaultNo.id,
            };

            if (virtualfair) {
                vm.virtualfair.id = virtualfair.id;
                vm.virtualfair.image_url = virtualfair.image_url;
                vm.virtualfair.whatsapp_community_url = virtualfair.whatsapp_community_url;
                vm.whatsapp_community_url = virtualfair.whatsapp_community_url;
                vm.virtualfair.name = virtualfair.name;
                vm.virtualfair.title = virtualfair.title;
                let expo_type = vm.expotypes.filter(item => item.id == virtualfair.expo_type_id);
                if (expo_type.length) {
                    vm.virtualfair.expo_type_id = expo_type[0].id;
                }
                vm.virtualfair.is_workshop = virtualfair.is_workshop;
                // vm.virtualfair.is_high_school = virtualfair.is_high_school;
                vm.virtualfair.has_networking_event = virtualfair.has_networking_event;
                vm.virtualfair.target_region = virtualfair.target_region;
                vm.virtualfair.target_students = virtualfair.target_students;
                vm.virtualfair.target_exhibitors = virtualfair.target_exhibitors;
                vm.virtualfair.booths_limit = virtualfair.booths_limit;
                vm.virtualfair.description = virtualfair.description;
                if (virtualfair.description_event_ics) {
                    vm.virtualfair.description_event_ics = virtualfair.description_event_ics;
                }
                if (virtualfair.description_booth_setup_ics) {
                    vm.virtualfair.description_booth_setup_ics = virtualfair.description_booth_setup_ics;
                }
                vm.virtualfair.logistics_url = virtualfair.logistics_url;
                vm.virtualfair.school_profile_url = virtualfair.school_profile_url;
                virtualfair.regions.filter(function (region) {
                    vm.virtualfair.service_regions.push(region.region.id);
                });
                virtualfair.pavilions.filter(function (pavillion) {
                    vm.addPavilion(pavillion)
                })
                virtualfair.sessions.filter(function (session) {
                    vm.addExpoSession(session)
                });
                vm.virtualfair.early_bird_datetime_utc = virtualfair.early_bird_datetime_utc;
                vm.virtualfair.registration_deadline = virtualfair.registration_deadline;
                vm.virtualfair.booth_setup_deadline = virtualfair.booth_setup_deadline;
                vm.virtualfair.student_registration_deadline = virtualfair.student_registration_deadline;
                vm.virtualfair.scheduling_deadline = virtualfair.scheduling_deadline;
                let currency = vm.currencies.filter(currency => currency.code == virtualfair.currency);
                if (currency.length) {
                    vm.virtualfair.currency = currency[0].code;
                }

                let cost_center = vm.costCenters.filter(cost_center => cost_center.id == virtualfair.cost_center_id);
                if (cost_center.length) {
                    vm.virtualfair.cost_center = cost_center[0];
                }
                vm.virtualfair.early_bird_rate = parseFloat(virtualfair.early_bird_rate).toFixed(2);
                vm.virtualfair.rate = parseFloat(virtualfair.rate).toFixed(2);
                vm.virtualfair.max_representatives = parseInt(virtualfair.max_representatives);
                virtualfair.profile_types.filter(function (profileType) {
                    vm.virtualfair.profile_types.push(profileType.profile_type.id);
                });
                vm.virtualfair.event_group_id = virtualfair.event_group_id;
                vm.isNovvaEvent = vm.virtualfair.event_group_id == 17;
                vm.virtualfair.platform_system = virtualfair.platform_system;
                vm.virtualfair.calendar_id = virtualfair.calendar_id;
                vm.virtualfair.room_free_limit = virtualfair.room_free_limit ? parseInt(virtualfair.room_free_limit) : 2;
                vm.virtualfair.room_rate = virtualfair.room_rate ? parseFloat(virtualfair.room_rate) : 500.00;
                vm.virtualfair.room_max_visitors = virtualfair.room_max_visitors ? parseInt(virtualfair.room_max_visitors) : 20;
                // vm.virtualfair.exhibitors_survey_url = virtualfair.exhibitors_survey_url ? virtualfair.exhibitors_survey_url : "";

                vm.virtualfair.test_date_start_utc = virtualfair.test_date_start_utc;
                vm.virtualfair.name_for_students = virtualfair.name_for_students;
                vm.virtualfair.has_matching = virtualfair.has_matching;
                vm.virtualfair.canceled = virtualfair.canceled;
                vm.virtualfair.ai_agent_rate = parseFloat(virtualfair.ai_agent_rate).toFixed(2);

                if (virtualfair.students_countries != null) {
                    let selectedIds = virtualfair.students_countries.split(",").map(id => id.trim());

                    vm.selectedCountries = vm.countries.filter(country =>
                      selectedIds.includes(country.id)
                    );

                    if (vm.selectedCountries) {
                        let usedTerritoryIds = [...new Set(vm.selectedCountries.map(c => c.territory_id))];

                        vm.selectedTerritories = vm.territories.filter(t =>
                          usedTerritoryIds.includes(t.id)
                        );
                    }
                }

                if (virtualfair.event_colors != null) {
                    let color = vm.eventsColors.find(function(item) {
                        return virtualfair.event_colors == item.colors;
                    });
                    vm.virtualfair.event_colors = color;
                }
                if (virtualfair.exhibitors_country != null) {
                    let country = vm.exhibitorsCountries.find(function(item) {
                        return virtualfair.exhibitors_country == item.iso;
                    });
                    vm.virtualfair.exhibitors_country = country;
                }

            } else {
                vm.addPavilion();
                vm.addExpoSession();
            }
        }

        async function saveVirtualFairSettings() {
            vm.flag = false;
            let fields = {};
            angular.copy(vm.virtualfair, fields);
            fields.service_regions = JSON.stringify(fields.service_regions);
            fields.logistics_pdf = vm.virtualfair.logistics_pdf;
            fields.image = vm.virtualfair.image;
            // fields.school_profiles_pdf = vm.virtualfair.school_profiles_pdf;
            fields.description_event_ics = vm.virtualfair.description_event_ics;
            fields.description_booth_setup_ics = vm.virtualfair.description_booth_setup_ics;
            fields.early_bird_datetime_utc = moment(vm.virtualfair.early_bird_datetime_utc).format('YYYY-MM-DD');
            fields.registration_deadline = moment(vm.virtualfair.registration_deadline).format('YYYY-MM-DD');
            fields.booth_setup_deadline = moment(vm.virtualfair.booth_setup_deadline).format('YYYY-MM-DD');
            fields.student_registration_deadline = moment(vm.virtualfair.student_registration_deadline).format('YYYY-MM-DD HH:mm');
            if (vm.virtualfair.has_networking_event == 1) {
                fields.scheduling_deadline = moment(vm.virtualfair.scheduling_deadline).format('YYYY-MM-DD HH:mm');
            } else {
                fields.scheduling_deadline = "";
            }
            $.each(fields.sessions, function (key, value) {
                value.expo_date = moment(value.expo_date).format('YYYY-MM-DD');
                value.start_datetime_utc = moment(value.start_datetime_utc).format('YYYY-MM-DD HH:mm:ss');
                value.end_datetime_utc = moment(value.end_datetime_utc).format('YYYY-MM-DD HH:mm:ss');
                value.close_platform_datetime_utc = moment(value.close_platform_datetime_utc).format('YYYY-MM-DD HH:mm:ss');
            });
            if (vm.virtualfair.cost_center) {
                fields.cost_center = vm.virtualfair.cost_center.id;
            }
            fields.pavilions = JSON.stringify(fields.pavilions);
            fields.sessions = JSON.stringify(fields.sessions);
            fields.profile_types = JSON.stringify(fields.profile_types);

            fields.name_for_students = vm.virtualfair.name_for_students;
            fields.test_date_start_utc = moment(vm.virtualfair.test_date_start_utc).format('YYYY-MM-DD HH:mm:ss');
            fields.has_matching = vm.virtualfair.has_matching;
            fields.canceled = vm.virtualfair.canceled;            
            fields.event_colors = JSON.stringify(vm.virtualfair.event_colors.colors);
            if (vm.selectedCountries) {
                fields.students_countries = vm.selectedCountries
                    .map(c => c.id)
                    .join(', ');
            }
            if (vm.virtualfair.exhibitors_country) {
                fields.exhibitors_country = vm.virtualfair.exhibitors_country.iso;
            }

            VirtualFairService.saveVirtualFairSettings(fields).then(function (response) {
                vm.flag = true;
                if (virtualfair) {
                    toastr.success('Virtual Event successfully updated!');
                    vm.virtualfair.logistics_url = response.data.logistics_url;
                    vm.goToList();
                } else {
                    toastr.success('Virtual Event successfully created!');
                    vm.goToList();
                }
            })
        }

        async function goToList() {
            return await $state.go('root.virtualfair.settings');
        }

        async function logisticsToPdf() {
            console.log(vm.virtualfair.logistics_url);
        }

        async function changeNetworkingEvent() {
            if (vm.virtualfair.has_networking_event == 0) {
                vm.virtualfair.scheduling_deadline = "";
            }
        }

        async function selectEventGroups() {
            VirtualFairService.getEventGroups().then(function (response) {
                vm.eventGroups = response.data;
                // vm.expos.unshift({id: -1, name: '--- All ---'});
            });
        }

        async function selectProfileTypes() {
            VirtualFairService.getProfileTypes().then(function (response) {
                vm.profileTypes = response.data;
            });
        }

        async function selectTerritories() {
            CountriesNewService.getTerritories().then(function (response) {
                vm.territories = response.data;
            });
        }

        async function selectCountries() {
            CountriesNewService.getCountries().then(function (response) {
                vm.countries = response.data;

                vm.exhibitorsCountries = angular.copy(vm.countries);
                vm.exhibitorsCountries.unshift({ id: '', iso: '', name: 'Worldwide' });
                        
            });
        }

        function getCountries() {
            vm.countries = []; 
            let promises = [];

            $.each(vm.selectedTerritories, function (key, territory_id) {
                let promise = CountriesNewService.getCountriesByTerritoryId(territory_id).then(function (response) {
                    return response.data; 
                });
                promises.push(promise);
            });

            Promise.all(promises).then(function (results) {
                vm.countries = [].concat(...results);

                vm.countries.sort(function (a, b) {
                    return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
                });                
            });
        }


        async function activate() {
            await vm.selectTerritories();
            await vm.selectCountries();
            await vm.selectExpoTypes();
            await vm.selectServiceRegions();
            await vm.selectCostCenter();
            await vm.selectCurrencies();
            await vm.selectEventGroups();
            await vm.selectProfileTypes();            
            await vm.getTitle();
            await vm.mountVirtualFair();

            // Parse colors
            vm.eventsColors.forEach(function(item) {
                item.colors = JSON.parse(item.colors);
            });
        }

        function changePlatform(value) {
            if(value == 1) {
                vm.virtualfair.room_free_limit = "";
                vm.virtualfair.room_rate = "";
                vm.virtualfair.room_max_visitors = "";
            }
        }

        async function selectAll() {
            vm.virtualfair.profile_types = vm.profileTypes.map(profile => profile.id);
        }

        async function removeAll() {
            vm.virtualfair.profile_types = [];
        }

        activate();

        function changeProfileTypes() {
            // Remove item "ADD ALL"
            vm.selectProfileTypes.pop();

            vm.profileTypes.map(function(item) {
                if (item !== '--- All ---') {
                    vm.selectProfileTypes.push(item);
                }
            })
        }

        function setStudentsAudience() {
            if(vm.virtualfair.target_students == null || vm.virtualfair.target_students.length == 0) {
                let countries = vm.selectedCountries;

                vm.virtualfair.target_students = countries
                    .map(c => c.name)
                    .join(', ');
            }
        }

        function setExhibitorsCountry() {
            vm.virtualfair.target_exhibitors = vm.virtualfair.exhibitors_country.name;
        }

        function setDates(session) {      
            const totalSessions = vm.virtualfair.sessions.length;
            const sessionStart = new moment(vm.virtualfair.sessions[0].start_datetime_utc);
            const currentSessionStart = new moment(session.start_datetime_utc);

            session.end_datetime_utc = currentSessionStart.clone().add(3, 'hours');
            session.close_platform_datetime_utc = session.end_datetime_utc.clone().add(30, 'minutes');
            vm.virtualfair.student_registration_deadline = sessionStart.clone().subtract(30, 'minutes');   

            // Test date
            let testDate = sessionStart.clone().subtract(2, 'days');
            if (testDate.day() === 6) {
              testDate.subtract(1, 'days'); // sábado → sexta
            } else if (testDate.day() === 0) {
              testDate.subtract(2, 'days'); // domingo → sexta
            }
            vm.virtualfair.test_date_start_utc = testDate.format('YYYY-MM-DD') + ' 00:00:00';     

            // Booth setup deadline
            let lastFriday = sessionStart.clone().startOf('day');
            const day = lastFriday.day();
            if (day !== 5) {
              const daysBackToFriday = (day + 2) % 7; // dias para voltar até sexta
              lastFriday.subtract(daysBackToFriday, 'days');
            }
            // Passo 2: subtrair mais 14 dias (duas sextas anteriores)
            lastFriday.subtract(14, 'days');
            // Resultado final:
            vm.virtualfair.booth_setup_deadline = lastFriday.format('YYYY-MM-DD');
            
            //Registration deadline
            let booth_setup_deadline = new moment(vm.virtualfair.booth_setup_deadline);
            vm.virtualfair.registration_deadline = booth_setup_deadline.clone().subtract(4, 'days');
        }
    }
})();